import { createSlice } from "@reduxjs/toolkit";

const jailIncidentsSlice = createSlice({
  name: "jailIncident",
  initialState: {
    jailIncident: null,
    jailIncidentBeforeModify: null,
  },
  reducers: {
    setJailIncidentStore: (state, action) => {
      state.jailIncident = { ...state?.jailIncident, ...action.payload };
    },
    setJailIncidentBeforeModify: (state, action) => {
      state.jailIncidentBeforeModify = action.payload;
    },
    setJailIncidentNull: (state) => {
      state.jailIncident = null;
    },
    setJailIncidentBeforeModifyNull: (state) => {
      state.jailIncidentBeforeModify = null;
    },
  },
});

export const {
  setJailIncidentStore,
  setJailIncidentNull,
  setDeleteAPIEmpty,
  setJailIncidentBeforeModify,
  setJailIncidentBeforeModifyNull,
} = jailIncidentsSlice.actions;
export default jailIncidentsSlice.reducer;
